import odata from "@/core/api/mixin/odata";
import rest from "@/core/api/mixin/rest";
import { apiClient } from "@/core/api/httpClient";

export default {
  ...odata("sync-data"),
  ...rest("sync-data"),
  getById: function (id) {
    return apiClient.get(`sync-data/${id}`, {
      params: {
        relations: "syncDataLogs",
      },
    });
  },
  rerun: function (id) {
    return apiClient.get(`sync-data/${id}/rerun`);
  },
};
